import Big from "big.js";
import { Currency, getCurrencyMinorUnits } from "./currencies";

/**
 * Stripe's minimum charge is 50 minor units in most currencies; these differ.
 * https://docs.stripe.com/currencies#minimum-and-maximum-charge-amounts
 */
const STRIPE_MINIMUM_MINOR_UNITS: Partial<Record<Currency, number>> = {
  [Currency.AED]: 200,
  [Currency.BGN]: 200,
  [Currency.CZK]: 1500,
  [Currency.DKK]: 250,
  [Currency.GBP]: 30,
  [Currency.HKD]: 400,
  [Currency.HUF]: 17_500,
  [Currency.MXN]: 1000,
  [Currency.MYR]: 200,
  [Currency.NOK]: 300,
  [Currency.PLN]: 200,
  [Currency.RON]: 200,
  [Currency.SEK]: 300,
  [Currency.THB]: 1000,
};

const DEFAULT_STRIPE_MINIMUM_MINOR_UNITS = 50;

export function stripeMinimumChargeMinorUnits(currency: Currency): number {
  return (
    STRIPE_MINIMUM_MINOR_UNITS[currency] ?? DEFAULT_STRIPE_MINIMUM_MINOR_UNITS
  );
}

/** Stripe's minimum charge in the currency's major units (e.g. 0.30 for GBP). */
export function stripeMinimumChargeAmount(currency: Currency): Big {
  return Big(stripeMinimumChargeMinorUnits(currency)).div(
    Big(10).pow(getCurrencyMinorUnits(currency)),
  );
}

/** Amount is in major units. Stripe would reject a charge for it. */
export function isBelowStripeMinimumCharge(
  amount: Big | number,
  currency: Currency,
): boolean {
  return Big(amount).lt(stripeMinimumChargeAmount(currency));
}
